import { useEffect, useId, useRef, useState } from 'react';
import { CircleHelp, Lightbulb, Sigma, X } from 'lucide-react';
import { fieldGuidance } from '../lib/fieldGuidance';

export default function FieldHelp({ guidanceKey }) {
  const guidance = fieldGuidance[guidanceKey];
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const popoverId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const closeOutside = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const closeEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeEscape);
    };
  }, [open]);

  if (!guidance) return null;

  return (
    <span
      className={`field-help ${open ? 'field-help--open' : ''}`}
      ref={rootRef}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        className="field-help__trigger"
        type="button"
        aria-label={`Explain ${guidance.title}`}
        aria-expanded={open}
        aria-controls={popoverId}
        onFocus={() => setOpen(true)}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((current) => !current);
        }}
      >
        <CircleHelp size={14} />
      </button>
      {open && (
        <span className="field-help__popover" id={popoverId} role="dialog" aria-label={`${guidance.title} guidance`}>
          <span className="field-help__topline">
            <strong>{guidance.title}</strong>
            <button type="button" aria-label="Close guidance" onClick={(event) => { event.preventDefault(); event.stopPropagation(); setOpen(false); }}><X size={14} /></button>
          </span>
          <span className="field-help__summary">{guidance.summary}</span>
          <span className="field-help__section"><Sigma size={14} /><span><b>How to calculate it</b>{guidance.calculate}</span></span>
          <span className="field-help__section field-help__section--benchmark"><Lightbulb size={14} /><span><b>Starting point</b>{guidance.benchmark}</span></span>
        </span>
      )}
    </span>
  );
}
